// Debug utility for consistent logging across the application
const isDevelopment = process.env.NODE_ENV === 'development';

export const debug = {
  // General logging
  log: (message, data = null) => {
    if (isDevelopment) {
      if (data) {
        console.log(`🔍 ${message}`, data);
      } else {
        console.log(`🔍 ${message}`);
      }
    }
  },

  // Error logging
  error: (message, error = null) => {
    if (isDevelopment) {
      if (error) {
        console.error(`❌ ${message}`, error);
      } else {
        console.error(`❌ ${message}`);
      }
    }
  },

  // Success logging
  success: (message, data = null) => {
    if (isDevelopment) {
      if (data) {
        console.log(`✅ ${message}`, data);
      } else {
        console.log(`✅ ${message}`);
      }
    }
  },

  // Warning logging
  warn: (message, data = null) => {
    if (isDevelopment) {
      if (data) {
        console.warn(`⚠️ ${message}`, data);
      } else {
        console.warn(`⚠️ ${message}`);
      }
    }
  },

  // Info logging
  info: (message, data = null) => {
    if (isDevelopment) {
      if (data) {
        console.info(`ℹ️ ${message}`, data);
      } else {
        console.info(`ℹ️ ${message}`);
      }
    }
  },

  // Component-specific logging
  component: {
    dashboard: (message, data = null) => debug.log(`Dashboard: ${message}`, data),
    quote: (message, data = null) => debug.log(`Quote: ${message}`, data),
    order: (message, data = null) => debug.log(`Order: ${message}`, data),
    customer: (message, data = null) => debug.log(`Customer: ${message}`, data),
    email: (message, data = null) => debug.log(`Email: ${message}`, data),
    sidebar: (message, data = null) => debug.log(`Sidebar: ${message}`, data),
    login: (message, data = null) => debug.log(`Login: ${message}`, data),
    settings: (message, data = null) => debug.log(`Settings: ${message}`, data),
    services: (message, data = null) => debug.log(`Services: ${message}`, data),
    about: (message, data = null) => debug.log(`About: ${message}`, data)
  },

  // Hook-specific logging
  hook: {
    realtime: (message, data = null) => debug.log(`Realtime: ${message}`, data),
    pagination: (message, data = null) => debug.log(`Pagination: ${message}`, data),
    filter: (message, data = null) => debug.log(`Filter: ${message}`, data),
    modal: (message, data = null) => debug.log(`Modal: ${message}`, data),
    form: (message, data = null) => debug.log(`Form: ${message}`, data)
  },

  // Service-specific logging
  service: {
    api: (message, data = null) => debug.log(`API: ${message}`, data),
    websocket: (message, data = null) => debug.log(`WebSocket: ${message}`, data),
    pdf: (message, data = null) => debug.log(`PDF: ${message}`, data)
  }
}; 